import { boolean, object } from "yup";
import { optionalEmail } from "../../../acd/util.js";
import { defaultAddress, defaultContextFields, generateDateBeforeTodayValidationRule, hospital, nameAndAddress, } from "../../../shared.js";
export const a2UploadablePart1DataSchema = object({
    ...defaultContextFields(),
    hospital: hospital,
    nearestRelativeKnown: boolean()
        .default(null)
        .required("Please confirm if the nearest relative is known"),
    nameAndAddressOfSignee: nameAndAddress({
        nameRequiredError: "Please enter name of signee",
        addressRequiredError: "Please enter address of signee",
    }, true).default(defaultAddress),
    emailAddressOfSignee: optionalEmail,
    lastSeenDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter date signee last saw the patient on"),
    medicalPractitionersPreviousAcquaintance: boolean()
        .default(null)
        .required("Please confirm if one of the medical practitioners have previous acquaintance with the patient before making their recommendation"),
    signatureDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter signature date "),
});
export const exampleA2UploadableData = [
    {
        data: {
            hospital: {
                name: "Hospital",
                address: "Hospital Address",
                postalCode: "ABC 123",
                isConfirmed: true,
            },
            user: {
                name: "AMHP",
                address: "AMHP Address",
                postalCode: "ABC 123",
                email: "david@amhp.com",
                isConfirmed: true,
                isGuest: false,
                isSection12Approved: false,
                localAuthority: "Local Authority",
            },
            emailAddressOfSignee: "stuart@thalamos.co.uk",
            patient: {
                name: "Patient",
                address: "Patient Address",
                postalCode: "ABC 123",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
            nameAndAddressOfSignee: {
                name: "name",
                address: "Address",
                isConfirmed: true,
                postalCode: "ABC 123",
            },
            nearestRelativeKnown: true,
            lastSeenDate: "2021-02-01",
            medicalPractitionersPreviousAcquaintance: true,
            signatureDate: "2021-03-01",
        },
    },
];
// TODO: Is this check helpful
// const _ = exampleA2UploadableData as ExampleFormData<A2Data>;
//# sourceMappingURL=a2.js.map